import { Collapsible as CollapsiblePrimitive } from "@base-ui/react/collapsible";
import type React from "react";

export const Collapsible = ({ ...props }: CollapsiblePrimitive.Root.Props): React.ReactElement => (
  <CollapsiblePrimitive.Root data-slot="collapsible" {...props} />
);

export const CollapsibleTrigger = ({
  className,
  ...props
}: CollapsiblePrimitive.Trigger.Props): React.ReactElement => (
  <CollapsiblePrimitive.Trigger className={className} data-slot="collapsible-trigger" {...props} />
);

export const CollapsiblePanel = ({
  className,
  ...props
}: CollapsiblePrimitive.Panel.Props): React.ReactElement => (
  <CollapsiblePrimitive.Panel className={className} data-slot="collapsible-panel" {...props} />
);

export { CollapsiblePrimitive, CollapsiblePanel as CollapsibleContent };
